export default __webpack_public_path__ + "static/media/boom.15f4fbec.ogg";